App.factory('profileService', ['$q', 'baseService', 'Config', function($q, baseService, Config) {
    function ProfileService() {
        this.dataUser = function() {
            return baseService.get(Config.API_URL + '/user/loggedUserData')
                .then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.dataPerson = function() {
            return baseService.get(Config.API_URL + '/user/person').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.editUser = function(data) {
            return baseService.post(Config.API_URL + '/user/update', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.getBankAccountNumber = function (project) {
            return baseService.get(Config.API_URL + '/user/bankAccountNumber?project=' + project).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.getBankAccountBalance = function (project) {
            return baseService.get(Config.API_URL + '/user/bankAccountBalance?project=' + project).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.editPasswordUser = function(data) {
            return baseService.post(Config.API_URL + '/user/changePassword', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.consentList = function() {
            return baseService.get(Config.API_URL + '/consent/last').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.consentEdit = function(data) {
            return baseService.post(Config.API_URL + '/consent/save', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.deleteAccount = function() {
            return baseService.get(Config.API_URL + '/user/deleteAccount').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };
    }
    return new ProfileService();
}]);